import { render, staticRenderFns } from "./CorrespondenceSalutationUpdate.vue?vue&type=template&id=1ef3c71e"
import script from "./CorrespondenceSalutationUpdate.vue?vue&type=script&lang=js"
export * from "./CorrespondenceSalutationUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports